/**
 * Created by ericm on 10/18/17.
 */
import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';

import template from './ns-currency.html';
import {CurrencyService} from '@nuskin/ns-shop';

/**
 * <p>The ns-currency should be used for displaying currency amounts with appropriate symbols.</p>
 *
 * <h1>Demo</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-currency></ns-currency>
 *     <br>
 *     <ns-currency amount="1300"></ns-currency>
 *     <br>
 *     <ns-currency amount="40.49" country="JP"></ns-currency>
 *     <br>
 *     <ns-currency amount="1000000.50" country="ES" language="en"></ns-currency>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsCurrency extends PolymerElement {
    static get properties() {
        return {
            /**
             * The amount you want to display. For some countries it is rounded to the nearest whole number
             */
            amount: {
                type: Number,
                observer: '_amountChanged'
            },
            blockload: {
                type: Boolean,
                reflectToAttribute: true
            }
        };
    }

   static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

   constructor() {
        super()
    }

    /**
     * Use the CurrencyService to format the currency
     */
    ready() {
        super.ready()
        // this.formattedCurrency = '---------';
        this.blockload = true;
        if (this.amount !== undefined && this.amount !== null) {
            this.formattedCurrency = CurrencyService.format(this.amount);
            if (typeof this.amount === "string") {
                if (this.amount.length > 0) this.blockload = false;
            } else {
                this.blockload = false;
            }
        }
    }

    /**
     * Format the currency again if the amount changes
     */
    _amountChanged(newValue, oldValue) {
        this.blockload = true;
        this.formattedCurrency = CurrencyService.format(this.amount);
        this.blockload = false;
    }
}
customElements.define('ns-currency', NsCurrency);
